"use client";

import { useAuth } from "./providers/AuthProvider";
import { PhoneLoginForm } from "./components/PhoneLoginForm";
import { ChatLayout } from "./components/ChatLayout";
import { WebSocketInit } from "./components/WebSocketInit";
import { OnboardingProvider } from "./providers/OnboardingProvider";
import AboutPage from "./about/page";

export default function Home() {
  const { ready, authenticated, user } = useAuth();

  if (!ready) {
    return (
      <div style={centerStyle}>
        <p style={{ color: "var(--color-text-faint)", fontSize: "0.85rem" }}>Loading...</p>
      </div>
    );
  }

  // Authenticated user with access — show the app
  if (authenticated && user?.hasAccess) {
    return (
      <OnboardingProvider>
        <WebSocketInit />
        <ChatLayout />
      </OnboardingProvider>
    );
  }

  // Authenticated but no access — show the About page
  if (authenticated) {
    return <AboutPage />;
  }

  // Not authenticated — show login form
  return (
    <div style={centerStyle}>
      <PhoneLoginForm />
    </div>
  );
}

const centerStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  flex: 1,
  minHeight: 0,
  paddingBottom: 28,
  overflow: "hidden",
};
